<template>
  <div>
    <!-- 合作方式 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>合作方设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <div v-for="(v,index) in titleList" :class="v.name=='绿云'?'activeLv':''" :key="index">
        <div>
          <div>{{v.name}}</div>
          <div class="setCur" @click="setFn(v)">设置></div>
        </div>
        <el-divider></el-divider>
        <div v-if="v.name=='去哪儿'">
          <div class="contents">
            <p>supplierIdentity：</p>
            <p>{{v.supplierIdentity}}</p>
          </div>
          <div class="contents">
            <p>signkey：</p>
            <p>{{v.signkey}}</p>
          </div>
        </div>
        <div v-if="v.name=='美团'">
          <div class="contents">
            <p>partnerId：</p>
            <p>{{v.partnerId}}</p>
          </div>
          <div class="contents">
            <p>clientId：</p>
            <p>{{v.clientId}}</p>
          </div>
          <div class="contents">
            <p>clientSecret：</p>
            <p>{{v.clientSecret}}</p>
          </div>
          <div class="contents">
            <p>版本：</p>
            <p>{{v.type == "1" ? "新金飞鹰" : "金飞鹰"}}</p>
          </div>
        </div>
        <div v-if="v.name=='携程'">
          <div class="contents">
            <p>accountid：</p>
            <p>{{v.accountid}}</p>
          </div>
          <div class="contents">
            <p>signkey：</p>
            <p>{{v.signkey}}</p>
          </div>
          <div class="contents">
            <p>aeskey：</p>
            <p>{{v.aeskey}}</p>
          </div>
          <div class="contents">
            <p>aesiv：</p>
            <p>{{v.aesiv}}</p>
          </div>
          <div class="contents">
            <p>url：</p>
            <p>{{v.url}}</p>
          </div>
        </div>
        <div v-if="v.name=='抖音'">
        <!-- 遍历显示所有抖音配置 -->
        <div v-for="(config, index) in v.douyinList" :key="index" class="douyin-config-item">
          <div class="contents">
            <p>门店id：</p>
            <p>{{config.poi_id.join(', ')}}</p>
          </div>
          <div class="contents">
            <p>抖音账户：</p>
            <p>{{config.account_id}}</p>
          </div>
          <el-divider></el-divider>
        </div>
        <!-- 如果没有配置显示提示 -->
        <div v-if="v.douyinList.length === 0" class="no-config">
          暂无抖音配置
        </div>
      </div>
        <div v-if="v.name=='快手'">
          <div class="contents">
            <p>门店id(poi_id)：</p>
            <p>{{v.poi_id}}</p>
          </div>
          <div class="contents">
            <p>主账号快手id：</p>
            <p>{{v.uid}}</p>
          </div>
        </div>
        <div class="lvyun" v-if="v.name=='绿云'">
          <div>
            <span>大会员配置</span>
            <div class="contents">
              <p>hotelGroupCode：</p>
              <p>{{v.hotelGroupCode}}</p>
            </div>
            <div class="contents">
              <p>hotelCode：</p>
              <p>{{v.hotelCode}}</p>
            </div>
            <div class="contents">
              <p>appKey：</p>
              <p>{{v.appKey}}</p>
            </div>
            <div class="contents">
              <p>secret：</p>
              <p>{{v.secret}}</p>
            </div>
            <div class="contents">
              <p>ly_url：</p>
              <p>{{v.ly_url}}</p>
            </div>
          </div>
          <div>
            <span>线上票务</span>
            <div class="contents">
              <p>apiKeyTicket：</p>
              <p>{{v.apiKeyTicket}}</p>
            </div>
            <div class="contents">
              <p>comKeyTicket：</p>
              <p>{{v.comKeyTicket}}</p>
            </div>
            <div class="contents">
              <p>xwturl：</p>
              <p>{{v.xwturl}}</p>
            </div>
            <div class="contents">
              <p>NotifyURL：</p>
              <p>{{v.NotifyURL}}</p>
            </div>
          </div>
          <div>
            <span>客房配置</span>
            <div class="contents">
              <p>hotelGroupCodeRoom：</p>
              <p>{{v.hotelGroupCodeRoom}}</p>
            </div>
            <div class="contents">
              <p>hotelGroupId：</p>
              <p>{{v.hotelGroupId}}</p>
            </div>
            <div class="contents">
              <p>hotelGroupDescript：</p>
              <p>{{v.hotelGroupDescript}}</p>
            </div>
            <div class="contents">
              <p>hotelurl：</p>
              <p>{{v.hotelurl}}</p>
            </div>
            <div class="contents">
              <p>hotelurl2：</p>
              <p>{{v.hotelurl2}}</p>
            </div>

            <!-- <div class="contents">
              <p>passwordRomm：</p>
              <p>{{v.passwordRomm}}</p>
            </div>
            <div class="contents">
              <p>usernameRoom：</p>
              <p>{{v.usernameRoom}}</p>
            </div>
            <div class="contents">
              <p>method：</p>
              <p>{{v.method}}</p>
            </div>
            <div class="contents">
              <p>hotelCodes：</p>
              <p>{{v.hotelCodes}}</p>
            </div>
            <div class="contents">
              <p>appKeyRoom：</p>
              <p>{{v.appKeyRoom}}</p>
            </div>
            <div class="contents">
              <p>appSecretRoom：</p>
              <p>{{v.appSecretRoom}}</p>
            </div>
            <div class="contents">
              <p>scene：</p>
              <p>{{v.scene}}</p>
            </div>
            <div class="contents">
              <p>format：</p>
              <p>{{v.format}}</p>
            </div>
            <div class="contents">
              <p>v：</p>
              <p>{{v.v}}</p>
            </div>
            <div class="contents">
              <p>local：</p>
              <p>{{v.local}}</p>
            </div>
            <div class="contents">
              <p>empno：</p>
              <p>{{v.empno}}</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 设置弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleType+'设置'"
      :visible.sync="setVisible"
      :before-close="setHandleClose"
      width="50%"
      center
      top="15vh"
    >
      <div class="divider">
        <el-divider></el-divider>
      </div>
      <div class="mtFrom" v-if="nameType=='美团'">
        <el-form ref="rulesform" :model="form" :rules="rules" label-width="180px">
          <el-form-item label="partnerld:" prop="partnerId">
            <el-input v-model.trim="form.partnerId" placeholder="请输入" ></el-input>
          </el-form-item>
          <el-form-item label="clientld:" prop="clientId">
            <el-input v-model.trim="form.clientId" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="clientsecret:" prop="clientSecret">
            <el-input v-model.trim="form.clientSecret" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="版本:" prop="type">
            <el-radio v-model="form.type" :label="1">新金飞鹰</el-radio>
            <el-radio v-model="form.type" :label="2">金飞鹰</el-radio>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <!-- <el-button>清空</el-button> -->
              <el-button class="btnL" @click="Meituan('rulesform')">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="mtFrom" v-if="nameType=='携程'">
        <el-form ref="form3" :model="form3" :rules="rules" label-width="180px">
          <el-form-item label="accountId:" prop="accountid">
            <el-input v-model.trim="form3.accountid" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="signKey:" prop="signkey">
            <el-input v-model.trim="form3.signkey" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="aesKey:" prop="aeskey">
            <el-input v-model.trim="form3.aeskey" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="aesIv:" prop="aesiv">
            <el-input v-model.trim="form3.aesiv" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="url:" prop="url">
            <el-input v-model.trim="form3.url" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <!-- <el-button>清空</el-button> -->
              <el-button class="btnL" @click="XCBtns('form3')">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="mtFrom" v-if="nameType=='去哪儿'">
        <el-form ref="form2" :model="form2" :rules="rules" label-width="180px">
          <el-form-item label="用户名（identity）:" prop="supplierIdentity">
            <el-input v-model.trim="form2.supplierIdentity" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="密码（secret）:" prop="signkey">
            <el-input v-model.trim="form2.signkey" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <!-- <el-button>清空</el-button> -->
              <el-button class="btnL" @click="QuNaBtns('form2')">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="mtFrom" v-if="nameType=='抖音'">
        <div class="douyin-header">
          <el-button type="primary" size="small" @click="addNewDouyinConfig">+ 新增配置</el-button>
          <span style="margin-left: 8px; color: red;">如需替换，请先删除要替换掉的配置！</span>
        </div>
        
        <el-collapse v-model="activeConfigIndex" accordion>
          <el-collapse-item 
            v-for="(config, index) in form4.douyinConfigs" 
            :key="index"
            :name="index"
            :title="'配置 ' + (index + 1) + (config.account_id ? ' - ' + config.account_id : '')"
          >
            <el-form 
              :ref="'douyinForm' + index" 
              :model="config" 
              :rules="douyinRules" 
              label-width="180px"
            >
              <el-form-item label="门店id:" prop="poi_id" v-if="config.poi_id && config.poi_id.length > 0">
                <el-tag 
                  :key="tag" 
                  v-for="tag in config.poi_id" 
                  :disable-transitions="false" 
                  @close="handleClose(tag, index)"
                >
                  {{tag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="DyInputVisible && DyInputIndex === index"
                  v-model="DyAddValue"
                  ref="saveTagInput"
                  size="medium"
                  @keyup.enter.native="handleInputConfirm(index)"
                  @blur="handleInputConfirm(index)"
                >
                </el-input>
                <!-- <el-button 
                  v-else 
                  class="button-new-tag" 
                  size="medium" 
                  @click="showDyInput(index)"
                >
                  + 新增门店ID
                </el-button> -->
              </el-form-item>
              
              <el-form-item label="抖音账户:" prop="account_id">
                <el-input v-model.trim="config.account_id" placeholder="请输入抖音账户" :readonly="idFlagFn(config.id)"></el-input>
              </el-form-item>
              
              <el-form-item>
                <div class="btn">
                  <el-popconfirm 
                    title="确认删除该配置吗？" 
                    @confirm="deleteDouyinConfig(config, index)"
                  >
                    <el-button slot="reference" type="danger" size="small">删除配置</el-button>
                  </el-popconfirm>
                </div>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        
        <div class="global-actions" v-if="form4.douyinConfigs.length > 0">
          <el-button class="btnL" @click="douyinUp(form4)">确认保存所有配置</el-button>
        </div>
      </div>
      <div class="mtFrom" v-if="nameType=='快手'">
        <el-form ref="form5" :model="form5" :rules="rules" label-width="180px">
          <el-form-item label="门店id(poi_id):" prop="poi_id">
            <el-input v-model.trim="form5.poi_id" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="主账号快手id:" prop="uid">
            <el-input v-model.trim="form5.uid" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <!-- <el-button>清空</el-button> -->
              <el-button class="btnL" @click="kuaishouUp('form5')">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="mtFrom" v-if="nameType=='绿云'">
        <el-form ref="form6" :model="form6" :rules="rules" label-width="180px">
          <div class="form_title">
            大会员配置
          </div>
          <div class="flex_lvyun">
            <el-form-item label="hotelGroupCode:">
              <el-input v-model.trim="form6.hotelGroupCode" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="hotelCode:" >
              <el-input v-model.trim="form6.hotelCode" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="flex_lvyun">
            <el-form-item label="appKey:" >
              <el-input v-model.trim="form6.appKey" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="secret:" >
              <el-input v-model.trim="form6.secret" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="flex_lvyun">
            <el-form-item label="ly_url:" >
              <el-input v-model.trim="form6.ly_url" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="form_title">
            线上票务
          </div>
          <div class="flex_lvyun">
            <el-form-item label="apiKeyTicket:" >
              <el-input v-model.trim="form6.apiKeyTicket" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="xwturl:" >
              <el-input v-model.trim="form6.xwturl" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="flex_lvyun">
            <el-form-item label="comKeyTicket:" >
              <el-input v-model.trim="form6.comKeyTicket" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="NotifyURL:" >
              <el-input v-model.trim="form6.NotifyURL" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="form_title">
            客房配置
          </div>
          <div class="flex_lvyun">
            <el-form-item label="hotelGroupCodeRoom:" >
              <el-input v-model.trim="form6.hotelGroupCodeRoom" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="hotelGroupId:" >
              <el-input v-model.trim="form6.hotelGroupId" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="flex_lvyun">
            <el-form-item label="hotelGroupDescript:" >
              <el-input v-model.trim="form6.hotelGroupDescript" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="hotelurl:" >
              <el-input v-model.trim="form6.hotelurl" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="flex_lvyun">
            <el-form-item label="hotelurl2:" >
              <el-input v-model.trim="form6.hotelurl2" placeholder="请输入"></el-input>
            </el-form-item>
            <!-- <el-form-item label="passwordRomm:" >
              <el-input v-model.trim="form6.passwordRomm" placeholder="请输入"></el-input>
            </el-form-item> -->
          </div>
<!-- 
          <div class="flex_lvyun">
            <el-form-item label="usernameRoom:" >
              <el-input v-model.trim="form6.usernameRoom" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="method:" >
              <el-input v-model.trim="form6.method" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="flex_lvyun">
            <el-form-item label="hotelCodes:" >
              <el-input v-model.trim="form6.hotelCodes" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="appKeyRoom:" >
              <el-input v-model.trim="form6.appKeyRoom" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="flex_lvyun">
            <el-form-item label="appSecretRoom:" >
              <el-input v-model.trim="form6.appSecretRoom" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="scene:" >
              <el-input v-model.trim="form6.scene" placeholder="请输入"></el-input>
            </el-form-item>
          </div> -->
          <!-- <div class="flex_lvyun">
            <el-form-item label="format:" >
              <el-input v-model.trim="form6.format" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="v:" >
              <el-input v-model.trim="form6.v" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="flex_lvyun">
            <el-form-item label="local:" >
              <el-input v-model.trim="form6.local" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="empno:" >
              <el-input v-model.trim="form6.empno" placeholder="请输入"></el-input>
            </el-form-item>
          </div> -->
          <el-form-item>
            <div class="btn">
              <el-button class="btnL" @click="lvyunBtns('form6')">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 设置弹框结束 -->
  </div>
</template>

<script>
import {supplySetQunar,
  supplySetMeituan,
  supplySetXiechen,
  supplySetMeituanSave,
  supplySetMeituanAdd,
  supplySetQunarAdd,
  supplySetQunarSave,
  supplySetXiechenAdd,
  supplySetXiechenSave,
  addKuaiShou,getKuaiShou,updateKuaiShou,
  getDouYin,addDouYin,updateDouYin ,deleteDouYin,
  LyScenicList , LyScenicAdd , LyScenicSave}  from '@/request/scenic.js'
  import {Message} from 'element-ui'
export default {
  data() {
    return {
      setVisible: false, // 点击设置
      titleType: "", // 弹框标题
      nameType: "", // 弹框显示内容
      titleList: [
        {
          name:'美团',
          partnerId:'',
          clientId:'',
          clientSecret:'',
          type: 1
        },
        {
          name:'携程',
          accountid:'',
          signkey:'',
          aesiv:'',
          aeskey:'',
          url:''
        },
        {
          name:'去哪儿',
          supplierIdentity:'',
          signkey:''
        },
        {
          name:'抖音',
          douyinList: []  // 改为数组形式，存储多个抖音配置
        },
        {
          name:'快手',
          poi_id:'',
          uid:''
        },
        {
          name:'绿云',
          hotelGroupCode:'',
          hotelCode:'',
          appKey:'',
          secret:'',
          ly_url:'',
          apiKeyTicket:'',
          comKeyTicket:'',
          NotifyURL:'',
          hotelGroupCodeRoom:'',
          hotelGroupId:'',
          hotelGroupDescript:'',
          hotelurl:'',
          hotelurl2:'',
          xwturl:'',

          passwordRomm:'',
          usernameRoom:'',
          method:'',
          hotelCodes:'',
          appKeyRoom:'',
          appSecretRoom:'',
          scene:'',
          format:'',
          v:'',
          local:"",
          empno:''
        }
      ],
      form6:{
        id:'',
        token:window.sessionStorage.getItem('Token'),
        hotelGroupCode:'',
        hotelCode:'',
        appKey:'',
        secret:'',
        ly_url:'',
        apiKeyTicket:'',
        comKeyTicket:'',
        NotifyURL:'',
        hotelGroupCodeRoom:'',
        hotelGroupId:'',
        hotelGroupDescript:'',
        hotelurl:'',
        hotelurl2:'',
        xwturl:'',
        passwordRomm:'',
        usernameRoom:'',
        method:'',
        hotelCodes:'',
        appKeyRoom:'',
        appSecretRoom:'',
        scene:'',
        format:'',
        v:'',
        local:"",
        empno:''
      },
      form: {
        token:window.sessionStorage.getItem('Token'),
        partnerId:'',
        clientId:'',
        clientSecret:'',
        type: 1,
      },
      form2:{
        token:window.sessionStorage.getItem('Token'),
        supplierIdentity:'',
        signkey:'',
        scenicid:'',
        id:''
      },
      MeituanFalse:false,
      QuNaFalse:false,
      XCFalse:false,
      form3:{
        token:window.sessionStorage.getItem('Token'),
        accountid:'',
        signkey:'',
        aeskey:'',
        aesiv:'',
        url:'',
        id:''
      },
      form4: {
        token: window.sessionStorage.getItem('Token'),
        douyinConfigs: [],  // 存储多个配置对象
        currentEditIndex: -1  // 当前编辑的索引
      },
      form5:{
        token:window.sessionStorage.getItem('Token'),
        poi_id:'',
        uid:'',
        id:''
      },
      listArr:[],
      rules:{
        partnerld: { required: true, message: '请输入partnerld', trigger: 'blur' },
        clientld: { required: true, message: '请输入clientld', trigger: 'blur' },
        clientsecret: { required: true, message: '请输入clientsecret', trigger: 'blur' },
        supplierIdentity: { required: true, message: '请输入supplierIdentity', trigger: 'blur' },
        signkey: { required: true, message: '请输入signkey', trigger: 'blur' },
        accountid:{ required: true, message: '请输入accountid', trigger: 'blur' },
        aeskey:{ required: true, message: '请输入aeskey', trigger: 'blur' },
        aesiv:{ required: true, message: '请输入aesiv', trigger: 'blur' },
        url:{ required: true, message: '请输入url', trigger: 'blur' },
        poi_id:{required: true, message: '请输入poi_id', trigger: 'blur'},
        uid:{required: true, message: '请输入uid', trigger: 'blur'}
      },
      DyInputVisible: false,
      DyAddValue: '',
      activeConfigIndex: 0,  // 当前激活的配置索引
      DyInputIndex: -1,      // 当前输入门店ID的配置索引
      douyinRules: {
        account_id: [
          { required: true, message: '请输入抖音账户', trigger: 'blur' }
        ]
      }
    };
  },
  created(){
    this.List()
  },
  methods: {
    lvyunBtns(form){
      this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.form6.id){
              LyScenicSave(this.form6).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              LyScenicAdd(this.form6).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 携程修改与添加
    XCBtns(form){
       this.titleList.map(item=>{
          if(item.name=='携程'){
            this.form3.id = item.id
          }
       })
     
      this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.XCFalse){
              // 
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='携程'){
                  if(this.titleList[i].accountid==this.form3.accountid&&this.titleList[i].signkey==this.form3.signkey&&this.titleList[i].aeskey==this.form3.aeskey&&this.titleList[i].aesiv==this.form3.aesiv){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
              supplySetXiechenSave(this.form3).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                    Message.error(res.data.msg)
                }
              })
            }else{
              supplySetXiechenAdd(this.form3).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                    Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 美团修改与添加
    Meituan(form){
      console.log(this.form)
       this.titleList.map(item=>{
          if(item.name=='美团'){
            this.form.id = item.id
          }
       })
     
       this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.MeituanFalse){
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='美团'){
                  if(this.titleList[i].clientId==this.form.clientId&&this.titleList[i].clientSecret==this.form.clientSecret&&this.titleList[i].partnerId==this.form.partnerId&&this.titleList[i].type==this.form.type){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
                supplySetMeituanSave(this.form).then(res=>{
                  if(res.data.status=='ok'){
                    this.setVisible = false;
                    this.List()
                    this.$message.success('修改成功')
                  }else{
                    Message.error(res.data.msg)
                  }
                })
              }else{
                supplySetMeituanAdd(this.form).then(res=>{
                  if(res.data.status=='ok'){
                    this.setVisible = false;
                    this.List()
                    this.$message.success('添加成功')
                  }else{
                    Message.error(res.data.msg)
                  }
                })
              }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 去哪儿修改与添加
    QuNaBtns(form){
      this.titleList.map(item=>{
          if(item.name=='去哪儿'){
            this.form2.id = item.id
          }
       })
       this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.QuNaFalse){
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='去哪儿'){
                  if(this.titleList[i].supplierIdentity==this.form2.supplierIdentity&&this.titleList[i].signkey==this.form2.signkey){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
              supplySetQunarSave(this.form2).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              supplySetQunarAdd(this.form2).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },  
    arraysEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) return false;
        }
        
        return true;
    },
    async douyinUp(form) {
      console.log("form", form);
      // 验证所有表单
      let allValid = true;
      const validationPromises = [];
      
      for (let i = 0; i < this.form4.douyinConfigs.length; i++) {
        validationPromises.push(
          new Promise((resolve) => {
            this.$refs[`douyinForm${i}`][0].validate((valid) => {
              resolve({ index: i, valid });
            });
          })
        );
      }
      
      const results = await Promise.all(validationPromises);
      const invalidConfigs = results.filter(r => !r.valid);

      if (invalidConfigs.length > 0) {
        allValid = false;
        // 跳转到第一个有错误的配置项
        this.activeConfigTab = invalidConfigs[0].index.toString();
        Message.error('请检查所有配置项的必填信息');
        return;
      }

      const allSavePromises = [];
      
      for (const config of this.form4.douyinConfigs) {
        // 为每个poi_id创建一个保存请求
          const savePromise = addDouYin({
            token: this.form4.token,
            account_id: config.account_id
          }).then(res => ({
            success: res.data.status === 'ok',
            message: res.data.msg,
            config: config,
          }));
          
          allSavePromises.push(savePromise);
      }

      try {
        const results = await Promise.all(allSavePromises);
        const successCount = results.filter(r => r.success).length;
        const totalCount = results.length;
        
        if (successCount === totalCount) {
          Message.success(`所有配置保存成功（共${totalCount}组）`);
          this.setVisible = false;
          await this.List();
        } else {
          const failedCount = totalCount - successCount;
          // Message.warning(`配置保存完成，成功${successCount}组，失败${failedCount}组`);
          // 可以显示具体失败的信息
          const failedItems = results.filter(r => !r.success);
          let msg = '';
          failedItems.forEach(item => {
            msg += `配置失败 - 账户: ${item.config.account_id}, 错误信息: ${item.message}\n`;
          });
          Message.warning(msg);
          console.error('失败的配置:', failedItems);
        }
      } catch (error) {
        Message.error('保存过程中发生错误：' + error.message);
      }
    },
    douyinDelete(form) {
      if (this.titleList[3].account_id == '') {
        Message.error("没有可删除的配置")
        return
      }
      
      let data = {
        token: this.form4.token,
        account_id: this.titleList[3].account_id
      }
      
      deleteDouYin(data).then(res => {
        if(res.status === 'ok'){
          Message({
            type: 'success',
            message: '删除成功'
          });
        }else {
          Message.error(res.data.msg);
        }
      })
    },
    kuaishouUp(form){
      this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.form5.id){
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='快手'){
                  if(this.titleList[i].poi_id==this.form5.poi_id&&this.titleList[i].uid==this.form5.uid){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
              updateKuaiShou(this.form5).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              addKuaiShou(this.form5).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    List(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      supplySetQunar(data).then(res=>{
        if(res.data.status=='ok'){
          this.titleList[2].supplierIdentity = res.data.result[0].supplierIdentity
          this.titleList[2].signkey = res.data.result[0].signkey
          this.titleList[2].id = res.data.result[0].id
          this.form2.scenicid = res.data.result[0].scenicid
        }
      })
      supplySetMeituan(data).then(res=>{
        if(res.data.status=='ok'){
            this.titleList[0].partnerId = res.data.result[0].partnerId
            this.titleList[0].clientSecret = res.data.result[0].clientSecret
            this.titleList[0].clientId = res.data.result[0].clientId
            this.titleList[0].id = res.data.result[0].id
            this.titleList[0].type = res.data.result[0].type || 1
        }
      })
      supplySetXiechen(data).then(res=>{
        if(res.data.status=='ok'){
          this.titleList[1].accountid=res.data.result[0].accountid
          this.titleList[1].signkey=res.data.result[0].signkey
          this.titleList[1].aeskey=res.data.result[0].aeskey
          this.titleList[1].aesiv=res.data.result[0].aesiv
          this.titleList[1].url=res.data.result[0].url
          this.titleList[1].id=res.data.result[0].id
        }
      })
      getKuaiShou(data).then(res=>{
        if(res.data.status=='ok'){
            this.titleList[4].poi_id = res.data.result.poi_id
            this.titleList[4].uid = res.data.result.uid
            this.titleList[4].id = res.data.result.id
        }
      })
      getDouYin(data).then(res=>{
        if(res.data.status=='ok'){
            const result = res.data.result;
            if (result && result.length > 0) {
              // 将数组直接赋值给douyinList
              this.titleList[3].douyinList = result.map(item => ({
                id: item.id,
                poi_id: Array.isArray(item.poi) && item.poi.length > 0 ? 
                      item.poi.map(p => p.poi_id) : 
                      (item.poi_id ? item.poi_id.split(',') : []),
                account_id: item.account_id || '',
                ids: Array.isArray(item.poi) ? 
                    item.poi.map(p => p.poi_id).join(', ') : 
                    (item.poi_id || '')
              }));
            } else {
              this.titleList[3].douyinList = [];
            }
        }
      })
      LyScenicList(data).then(res=>{
        if(res.data.status=='ok'){
            // this.titleList[5].poi_id = res.data.result.poi_id
            // this.titleList[5].id = res.data.result.id
            // this.titleList[5].account_id = res.data.result.account_id
            this.titleList[5].hotelGroupCode = res.data.result[0].hotelGroupCode
            this.titleList[5].hotelCode = res.data.result[0].hotelCode
            this.titleList[5].appKey = res.data.result[0].appKey
            this.titleList[5].secret = res.data.result[0].secret
            this.titleList[5].ly_url = res.data.result[0].ly_url
            this.titleList[5].apiKeyTicket = res.data.result[0].apiKeyTicket
            this.titleList[5].comKeyTicket = res.data.result[0].comKeyTicket
            this.titleList[5].NotifyURL = res.data.result[0].NotifyURL
            this.titleList[5].hotelGroupCodeRoom = res.data.result[0].hotelGroupCodeRoom
            this.titleList[5].hotelGroupId = res.data.result[0].hotelGroupId
            this.titleList[5].hotelGroupDescript = res.data.result[0].hotelGroupDescript
            this.titleList[5].hotelurl =  res.data.result[0].hotelurl
            this.titleList[5].hotelurl2 = res.data.result[0].hotelurl2
            this.titleList[5].xwturl = res.data.result[0].xwturl
            this.form6.id = res.data.result[0].id
            this.titleList[5].passwordRomm = res.data.result[0].passwordRomm
            this.titleList[5].usernameRoom = res.data.result[0].usernameRoom
            this.titleList[5].method = res.data.result[0].method
            this.titleList[5].hotelCodes = res.data.result[0].hotelCodes
            this.titleList[5].appKeyRoom = res.data.result[0].appKeyRoom
            this.titleList[5].appSecretRoom = res.data.result[0].appSecretRoom
            this.titleList[5].scene = res.data.result[0].scene
            this.titleList[5].format = res.data.result[0].format
            this.titleList[5].v = res.data.result[0].v
            this.titleList[5].local = res.data.result[0].local
            this.titleList[5].empno = res.data.result[0].empno
        }
      })
      this.listArr = this.titleList
    },
    // 点击设置
    setFn(v) {
      this.nameType = v.name;
      if (v.name == "美团") {
        this.form.partnerId=v.partnerId
        this.form.clientId=v.clientId
        this.form.clientSecret=v.clientSecret
        this.form.type=v.type || 1
        if(v.partnerId&&v.clientId&&v.clientSecret&&this.form.type){
          this.MeituanFalse = true
        }
        this.titleType = "美团";
      }
      if (v.name == "携程") {
        this.titleType = "携程";
        this.form3.accountid=v.accountid
        this.form3.signkey=v.signkey
        this.form3.aeskey=v.aeskey
        this.form3.aesiv=v.aesiv
        this.form3.url=v.url
        if(v.accountid&&v.signkey&&v.aeskey&&v.aesiv&&v.url){
          this.XCFalse = true
        }
      }
    
      if (v.name == "去哪儿") {
        this.titleType = "去哪儿";
        this.form2.supplierIdentity = v.supplierIdentity
        this.form2.signkey  = v.signkey
        if(v.signkey&&v.supplierIdentity){
          this.QuNaFalse = true
        }
      }
      if(v.name === '抖音'){
        this.titleType = "抖音";
        
        // 初始化form4
        this.form4 = {
          token: window.sessionStorage.getItem('Token'),
          douyinConfigs: [],
          currentEditIndex: -1
        };
        
        // 如果有现有数据，加载到form4中
        if (v.douyinList && v.douyinList.length > 0) {
          this.form4.douyinConfigs = v.douyinList.map(item => ({
            poi_id: Array.isArray(item.poi_id) ? item.poi_id : [item.poi_id],
            account_id: item.account_id,
            id: item.id || ''
          }));
          this.form4.douyinConfigs = JSON.parse(JSON.stringify(this.form4.douyinConfigs));
        } else {
          // 如果没有数据，添加一个空配置
          this.addNewDouyinConfig();
        }
      }
      if(v.name=='快手'){
        this.titleType = "快手";
        this.form5.poi_id = v.poi_id
        this.form5.id  = v.id
        this.form5.uid  = v.uid
        console.log(this.form4)
      }
      if(v.name=='绿云'){
        this.titleType = "绿云";
        this.form6 = {
          id:this.form6.id,
          token:window.sessionStorage.getItem('Token'),
          hotelGroupCode:v.hotelGroupCode,
          hotelCode:v.hotelCode,
          appKey:v.appKey,
          secret:v.secret,
          ly_url:v.ly_url,
          apiKeyTicket:v.apiKeyTicket,
          comKeyTicket:v.comKeyTicket,
          NotifyURL:v.NotifyURL,
          hotelGroupCodeRoom:v.hotelGroupCodeRoom,
          hotelGroupId:v.hotelGroupId,
          hotelGroupDescript:v.hotelGroupDescript,
          hotelurl:v.hotelurl,
          hotelurl2:v.hotelurl2,
          xwturl:v.xwturl
        }
      }
      this.setVisible = true;
    },
    // 点击设置X
    setHandleClose() {
      this.setVisible = false;
    },

    // 修改门店ID相关方法，增加索引参数
    handleClose(tag, index) {
      this.form4.douyinConfigs[index].poi_id.splice(
        this.form4.douyinConfigs[index].poi_id.indexOf(tag), 1
      );
    },

    showDyInput(index) {
      this.DyInputVisible = true;
      this.DyInputIndex = index;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    // 添加新的抖音配置
    addNewDouyinConfig() {
      this.form4.douyinConfigs.push({
        poi_id: [],
        account_id: '',
        id: ''  // 如果有id表示是已存在的配置
      });
      this.activeConfigIndex = this.form4.douyinConfigs.length - 1;
    },

    idFlagFn(id){
      return id ? true : false;
    },
    
    // 删除单个配置
    deleteDouyinConfig(config, index) {
      if(config.id){
        // 如果有id，说明是已存在的配置，需要调用删除接口
        deleteDouYin({
          token: this.form4.token,
          account_id: config.account_id
        }).then(res => {
          console.log(res);
          if(res.data.status === 'ok'){
            Message({
              type: 'success',
              message: '删除成功'
            });
            this.List()
            // 从本地数组中删除
            this.form4.douyinConfigs.splice(index, 1);
            if (this.form4.douyinConfigs.length > 0) {
              this.activeConfigIndex = 0;
            }
          }else {
            Message.error(res.data.msg);
          }
        });
      }else {
        // 直接从本地数组中删除
        this.form4.douyinConfigs.splice(index, 1);
        if (this.form4.douyinConfigs.length > 0) {
          this.activeConfigIndex = 0;
        }
      }
    },

    handleInputConfirm(index) {
      let inputValue = this.DyAddValue;
      if (inputValue) {
        let poiArray = this.form4.douyinConfigs[index].poi_id;
        if (poiArray.findIndex(item => item == inputValue) === -1) {
          poiArray.push(inputValue);
        } else {
          Message.warning("门店ID已存在！");
        }
      }
      this.DyInputVisible = false;
      this.DyAddValue = '';
      this.DyInputIndex = -1;
    },
  }
};
</script>

<style lang='less' scoped>
.divider {
  // 分割线
  /deep/.el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 10px 0 20px 0;
  }
}
/deep/.el-descriptions-item__content {
  word-break: break-word;
  overflow-wrap: break-word;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
/deep/.el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 10px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
.mtFrom {
  .el-form-item {
    position: relative;
  }
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -84px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -72px;
    color: #e74c3c;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -98px;
    color: #e74c3c;
  }
  .xingX {
    position: absolute;
    top: 0px;
    left: -143px;
    color: #e74c3c;
  }
  .xingZ {
    position: absolute;
    top: 0px;
    left: -118px;
    color: #e74c3c;
  }
  .xing1 {
    position: absolute;
    top: 0px;
    left: -89px;
    color: #e74c3c;
  }
  .xing2 {
    position: absolute;
    top: 0px;
    left: -74px;
    color: #e74c3c;
  }
  .xing3 {
    position: absolute;
    top: 0px;
    left: -68px;
    color: #e74c3c;
  }
  .xing4 {
    position: absolute;
    top: 0px;
    left: -57px;
    color: #e74c3c;
  }
  .xing5 {
    position: absolute;
    top: 0px;
    left: -40px;
    color: #e74c3c;
  }
  .el-input {
    // width: 350px;
  }
}
/deep/.el-descriptions-item__cell .el-descriptions-item__label {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 0px;
}
/deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 5px;
}

.content {
  width: 100%;
  height: 100%;
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  > div {
    min-width: 23%;
    width: auto;
    background: #ffffff;
    border-radius: 4px;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 20px;
    > div:nth-child(1) {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      > div:nth-child(1) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
      }
      > div:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
      }
    }
  }
}
// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0 10px 0;
}
.btn {
  // margin: 20px 100px 10px 0;
  margin-top: 20px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}
/deep/ .tbody{
  display: flex;
}
.contents{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1.3rem;
  font-size: 1.4rem;
}
.contents p:nth-child(2){
  color: #000;
  table-layout: fixed;
  word-break: break-all;
  overflow: hidden;
}
.contents p{
  padding: 0;
  font-size: 1.4rem;
}
.flex_lvyun{
  display: flex;
  align-items: center;
  ::v-deep .el-form-item{
    width: 50%;
  }
}

.lvyun{
  display: flex;
  >div{
    margin-left: 2rem;
    width: 30rem;
    >span{
      color: #000;
      font-weight: 600;
      font-weight: 2rem;
    }
  }
}
.form_title{
  font-weight: 600;
  font-size: 1.6rem;
  color: #000;
  margin-bottom: 1rem;
}
/deep/ .el-tag {
  margin-right: 10px;
  margin-bottom: 10px;
  height: 40px;
  line-height: 40px;
}
/deep/ .el-tag + .el-tag {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-tag .el-icon-close{
  height: 20px;
  width: 20px;
  line-height: 20px;
}
.button-new-tag {
  height: 40px;
  line-height: 35px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 200px;
  margin-bottom: 10px;
  vertical-align: bottom;
}
.global-confirm {
  z-index: 9999999 !important;
}

.douyin-config-item {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
}

.douyin-header {
  margin-bottom: 20px;
}

.global-actions {
  margin-top: 20px;
  text-align: center;
}

.no-config {
  text-align: center;
  color: #999;
  padding: 20px;
}
</style>